import { Alert } from "./alert.model";

export class MessageModel implements Alert {
    public id: number = 0;
    public title: string = '';
    public message: string = '';
    public shown: boolean = false;
    public type: number = 0;
    public property_id: number = 0;
    public user_id: number = 0;
    public for_id: number = 0;
    public created_at: Date = new Date();
    public advance_id: number = 0;
    public read: boolean = false;

    constructor() {}

    static fromJson(object: any): MessageModel {
        const result = new MessageModel();

        result.title = object?.notification?.title ?? '';
        result.message = object?.notification?.body ?? '';
        result.shown = true;
        result.read = false;

        if (object.data?.id) {
            result.id = parseInt(object.data.id, 10);
        }

        if (object.data?.type) {
            result.type = parseInt(object.data.type, 10);
        }

        if (object.data?.property_id) {
            result.property_id = parseInt(object.data.property_id, 10);
        }

        if (object.data?.user_id) {
            result.user_id = parseInt(object.data.user_id, 10);
        }

        if (object.data?.for_id) {
            result.for_id = parseInt(object.data.for_id, 10);
        }

        if (object.data?.created_at) {
            result.created_at = object.data.created_at;
        }

        if (object.data?.advance_id) {
            result.advance_id = object.data.advance_id;
        }

        return result;
    }
}